module.exports = __webpack_public_path__ + "img/vc.0d135a5a.svg";